import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { SchoolService } from "../../../../shared/services/school.service";
import { SchoolselectorService } from "../../../schoolselector/schoolselectorservice.service";
import { DataService_ClassroomAdmin } from "../shared/data.service";
import * as moment from "moment";

@Component({
	selector: "caass-course-selector",
	templateUrl: "./course-selector.component.html",
	styleUrls: ["./course-selector.component.css"],
})
export class CourseSelectorComponent implements OnInit {
	constructor(private selectService: SchoolselectorService, private classAdminService: DataService_ClassroomAdmin, private SchoolService: SchoolService) {}

	ngOnInit(): void {
		// this.loadSchools();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////
	subscription: any;

	@Output() SectionSelected: EventEmitter<any> = new EventEmitter();

	SchoolID: any = 0;
	lstSchool: any = [];

	SelectDate: any = new Date();

	SemesterList: any = []; //Used by date picker
	SemesterSelect: any;

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedSection: any;
	lstSection: any = [];

	//Filter lists
	lstCourseDesc: any = [];
	lstSemester: any = [];
	lstPeriodNo: any = [];
	lstInstructorDesc: any = [];
	lstDayDesc: any = [];
	lstRoomNo: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "CourseDesc", header: "Course" },
		{ field: "SectionNo", header: "Section" },
		{ field: "Semester", header: "Semester" },
		{ field: "PeriodNo", header: "Period" },
		{ field: "InstructorDesc", header: "Instructor" },
		{ field: "DayDesc", header: "Day" },
		{ field: "RoomNo", header: "Room" },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////
	loadSchools() {
		var result = this.SchoolService.loadSchoolList("");
		result.subscribe(
			(response) => {
				this.lstSchool = response;

				this.SchoolID = this.lstSchool[0].SchoolID;

				// this.loadSection();
				this.loadSemesters();
			},
			(error) => {}
		);
	}

	loadSection() {
		this.loading = true;

		var formattedDate = moment(this.SelectDate).format("MM/DD/YYYY");

		if (formattedDate != "Invalid date") {
			var result = this.classAdminService.LoadSectionByDate(this.SchoolID, formattedDate);
			result.subscribe(
				(response) => {
					this.lstSection = response;

					//Load Data Filter Lists
					this.lstCourseDesc = Array.from(new Set(this.lstSection.map((item: any) => item.CourseDesc))).sort();
					this.lstSemester = Array.from(new Set(this.lstSection.map((item: any) => item.Semester))).sort();
					this.lstPeriodNo = Array.from(new Set(this.lstSection.map((item: any) => item.PeriodNo))).sort();
					this.lstInstructorDesc = Array.from(new Set(this.lstSection.map((item: any) => item.InstructorDesc))).sort();
					this.lstDayDesc = Array.from(new Set(this.lstSection.map((item: any) => item.DayDesc))).sort();
					this.lstRoomNo = Array.from(new Set(this.lstSection.map((item: any) => item.RoomNo))).sort();

					this.loading = false;
				},
				(error) => {}
			);
		}
	}

	loadSemesters() {
		var result = this.classAdminService.LoadSemesters(this.SchoolID);
		result.subscribe(
			(response) => {
				this.SemesterList = response;

				if (this.SemesterList.length > 0) {
					for (var i = 0; i < this.SemesterList.length; i++) {
						var next = this.SemesterList[i];

						var formStart = moment(new Date(next.StartDate)).format("MM/DD/YYYY");
						var formEnd = moment(new Date(next.EndDate)).format("MM/DD/YYYY");

						next.Desc = " " + formStart + " - " + formEnd;
						next.FullDesc = "(" + next.Semester + "): " + formStart + " - " + formEnd;
					}

					//this.SemesterSelect = this.SemesterList[0];
					////this.SelectDate = new Date(this.SemesterSelect.StartDate);
					//this.loadSection();
				} else {
					this.SemesterList.unshift({
						SemesterID: -1,
						Semester: "No Results Found",
						Desc: "No Results Found",
						FullDesc: "No Results Found",
					});
				}
			},
			(error) => {}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onSchoolChange(val) {
		this.SchoolID = val;
		this.SendData(1);

		// this.loadSection();
		this.loadSemesters();
	}
	onDateChange(val) {
		this.SelectDate = val;
		this.SendData(1);

		this.loadSection();
	}
	onSemesterChange(val) {
		this.SemesterSelect = val;

		this.SelectDate = new Date(this.SemesterSelect.StartDate);
		this.SendData(1);

		this.loadSection();
	}

	onDeselectSemester(val) {
		this.SelectDate = new Date(this.SemesterSelect.StartDate);
		this.SendData(1);

		this.loadSection();
	}

	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedSection = val.data;

		this.SendData(1);
	}
	onRowUnselect(val) {
		this.SelectedSection = null;

		this.SendData(null);
	}

	SendData(val) {
		if (val == null) {
			this.SectionSelected.emit(null);
		} else {
			let data: any = {
				SectionScheduleDetailID: this.SelectedSection != undefined ? this.SelectedSection.SectionScheduleDetailID : -1,
				SelectDate: this.SelectDate,
				SchoolID: this.SchoolID,
			};

			this.SectionSelected.emit(data);
		}
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////

	////////////////////////////////////////////
}
